import type { ComponentStyle } from "@yamada-ui/core"

export const FormatByte: ComponentStyle<"FormatByte"> = {}
